export default function VisualizerColorsPdp({
  products,
  currentProduct,
  resetCurrentProduct,
  width,
  height,
}) {
  return (
    <div className="visualizerColors">
      {products?.map((product) => {
        return (
          product?.visualizable &&
          product?.visualizable == true &&
          product?.upid &&
          product.upid != "" && (
            <div className="slide color-box" key={product.sku}>
              <figure class="color-boxs-inner">
                <div
                  class={`color-boxs-inners ${
                    product.sku === currentProduct ? "active" : ""
                  }`}>
                  <div
                    class="swatch-img-holder"
                    onClick={() => resetCurrentProduct(product)}>
                    <img
                      src={`https://mm-media-res.cloudinary.com/image/fetch/h_${height},w_${width},c_limit/https://${product.swatch.replace(
                        /^https?:\/\//,
                        "",
                      )}`}
                      width={width}
                      height={height}
                      className="swatch-img"
                    />
                  </div>
                </div>
              </figure>
            </div>
          )
        );
      })}
    </div>
  );
}
